export default "__VITE_ASSET__73c75508__"